import { MessageChannel } from 'config/CustomEnums';

export const getDisplayPerformanceFields = (message) => {
    const messageChannelsMap = {
      Inbox: 'inbox',
      SMS: 'sms',
      Whatsapp: 'whatsapp',
      Email: 'email',
      Push: 'push',
    };
    let displayFields = [
      [
        {
          title: `Total messages sent`,
          field: `displayCreditSpent`,
        },
      ],
      [
        {
          title: `Total message sent in Whatsapp`,
          field: `displayWhatsappCreditSpent`,
        },
      ],
      [
        {
          title: `Total message sent in SMS`,
          field: `displaySmsCreditSpent`,
        },],
      [
        {
          title: `Total message sent in Email`,
          field: `displayEmailCreditSpent`,
        },]
    ];
    let channels = message?.channels;
    if (message?.channels?.indexOf(MessageChannel.all) !== -1) {
      channels = [
        MessageChannel.inbox,
        MessageChannel.push,
        MessageChannel.sms,
        MessageChannel.email,
      ];
    } else if (message?.channels?.indexOf(MessageChannel.allWhatsapp) !== -1) {
      channels = [
        MessageChannel.inbox,
        MessageChannel.push,
        MessageChannel.whatsapp,
        MessageChannel.email,
      ];
    }

    // eslint-disable-next-line no-unused-expressions
    channels?.forEach((channel) => {
      if (![MessageChannel.sms, MessageChannel.whatsapp].includes(channel) && messageChannelsMap?.[channel]) {
        displayFields.push([
          {
            title: `${channel} click rate (click/opend)`,
            field: `display${messageChannelsMap?.[channel]}ClickRate`,
          },
        ]);
        displayFields.push([
          {
            title: `${channel} open rate (opened/sent)`,
            field: `display${messageChannelsMap?.[channel]}OpenRate`,
          },
        ]);
        return;
      }
      if ([MessageChannel.sms, MessageChannel.whatsapp].includes(channel) && messageChannelsMap?.[channel]) {
        displayFields.push([
          {
            title: `${channel} click rate (click/sent)`,
            field: `display${messageChannelsMap?.[channel]}ClickRate`,
          },
        ]);
      }
    });
    return displayFields;
  };